import { Record, List } from 'immutable'

const SubBudgetRecord = Record({
  id: undefined,
  name: '',
  budgetId: undefined,
  budgetName: '',
  companyCode: undefined,
  displayDecimalsAmount: 0,
  dimensionTarget: {
    dimensionValues: List(),
    id: undefined,
  },
  presentationType: null,
  status: undefined,
  customStatus: undefined,
  readAndEditPermissionRoles: List(),
  readPermissionRoles: List(),
})

export default SubBudgetRecord
